import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";

import { IFilterInstallations } from "../supportObjects/IFilterInstallations";
import { IPaginationFilter } from "../supportObjects/IPaginationFilter";
import { TagValues } from "@/model/data/Tag";
import { FetchInstallationsCaosUserSyncConfigurationResData } from "./FetchInstallationsCaosUserSyncConfigurationResData";

const ENDPOINT = "/caosconfiguration/usersync/installations";

export class FetchInstallationsCaosUserSyncConfigurationCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: FetchInstallationsCaosUserSyncConfigurationReqData;

    constructor(payload: FetchInstallationsCaosUserSyncConfigurationReqData) {
        super();
        this.payload = payload;
    }

    public async execute(): Promise<FetchInstallationsCaosUserSyncConfigurationResData> {
        let res = await this.executeCommand(this.payload);
        return new FetchInstallationsCaosUserSyncConfigurationResData(res);
    }
}

export class FetchInstallationsCaosUserSyncConfigurationReqData implements IFilterInstallations, IPaginationFilter {
    // FilterInstallations
    installationNames: string[] = null;
    folderIds: number[] = null;
    branchNames: string[] = [];

    // PaginationFilters
    queryLimit: number = 0;
    offset: number = 0;
    orderBy: string[] = null;
    orderByDescending: boolean[] = null;

    // Other filters
    installationLastMessageDateRange: string[] = [];
    agentLastMessageDateRange: string[] = [];
    machineModels: string[] = null;
    tagValues: TagValues = null;

    syncToInstallationName: string = null;
    syncRole: string[] = [];
    lastSynchronizationDateRange: string[] = [];
}
